import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { AdminService } from '@app/core/services/admin.service';
import { FaultedInvoiceModel } from '@app/core/models/invoices/faulted-invoice.model';

@Injectable({ providedIn: 'root' })
export class FaultedInvoicesResolver  {
    constructor(private adminService: AdminService) { }

    resolve(): Observable<FaultedInvoiceModel[]> | Promise<FaultedInvoiceModel[]> | FaultedInvoiceModel[] {
        return this.adminService.getFaultedInvoices();
    }
}
